var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvantage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8706 32.6412C19.3795 31.053 27.6564 26.1469 27.6564 15.204V8.59298C27.6564 6.7305 27.6564 5.79787 27.2936 5.0858C26.9742 4.45883 26.4631 3.94946 25.8361 3.63001C25.1234 3.26683 22.2542 2.66269 22.2542 2.66269L19.3667 2.05699C16.0443 1.36003 12.6132 1.36181 9.29146 2.06219L6.28134 2.69688C6.28134 2.69688 3.53173 3.26683 2.81896 3.63001C2.192 3.94946 1.68263 4.45883 1.36317 5.0858C1 5.79856 1 6.73232 1 8.59845V15.204C1 26.1469 9.27649 31.053 12.7854 32.6412C13.1574 32.8096 13.3443 32.8936 13.7653 32.9659C14.0309 33.0115 14.6272 33.0115 14.8928 32.9659C15.3124 32.8939 15.4973 32.8102 15.8668 32.643L15.8706 32.6412Z",
    stroke: "#B068EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.476 28.6404C18.0874 27.4584 24.2472 23.8073 24.2472 15.6635V10.7435C24.2472 9.35738 24.2472 8.6633 23.9772 8.13338C23.7394 7.66678 23.3591 7.2877 22.8925 7.04996C22.362 6.77968 20.2268 6.33008 20.2268 6.33008L19.3666 6.14964C16.0442 5.45268 12.6131 5.45446 9.29134 6.15485L8.33961 6.35552C8.33961 6.35552 6.29332 6.77968 5.76287 7.04996C5.29628 7.2877 4.9172 7.66678 4.67946 8.13338C4.40918 8.66382 4.40918 9.35874 4.40918 10.7475V15.6634C4.40918 23.8073 10.5686 27.4584 13.18 28.6404C13.4568 28.7657 13.5959 28.8283 13.9093 28.8821C14.1069 28.916 14.5507 28.916 14.7483 28.8821C15.0606 28.8284 15.1982 28.7661 15.4732 28.6417L15.476 28.6404Z",
    fill: "#B068EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantage2);
export default __webpack_public_path__ + "static/media/advantage-2.d59a16721274c9dd603858f0215de44d.svg";
export { ForwardRef as ReactComponent };